import { useState } from "react";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import axios from "axios";
import { DASHBOARD_POLL_INTERVAL_MS } from "../config/appConstants";
import { API } from "../config/trading";
import { apiErrorMessage } from "../lib/errorMessage";

const DEFAULT_SELECTED_SYMBOL = "BTC-USDT";
const DASHBOARD_QUERY_KEY = ["trading-dashboard"];
const DEFAULT_RISK = { max_trade_usdt: 250, daily_loss_limit_usdt: 150 };

async function fetchDashboard() {
  const { data } = await axios.get(`${API}/trading/dashboard`);
  return data;
}

export function useDashboardData() {
  const queryClient = useQueryClient();
  const [selectedSymbolOverride, setSelectedSymbolOverride] = useState(null);
  const [riskDraft, setRiskDraft] = useState(null);
  const { data: dashboard, isLoading, error, refetch } = useQuery({
    queryKey: DASHBOARD_QUERY_KEY,
    queryFn: fetchDashboard,
    refetchInterval: DASHBOARD_POLL_INTERVAL_MS,
  });

  const setDashboard = (updater) => {
    queryClient.setQueryData(DASHBOARD_QUERY_KEY, updater);
  };

  const setSelectedSymbol = async (symbol) => {
    setSelectedSymbolOverride(symbol);
    await axios.put(`${API}/preferences`, { selected_symbol: symbol });
  };

  const risk = riskDraft || dashboard?.risk || DEFAULT_RISK;
  const selectedSymbol = selectedSymbolOverride || dashboard?.preferences?.selected_symbol || DEFAULT_SELECTED_SYMBOL;
  const loadDashboard = refetch;
  const errorMessage = error ? apiErrorMessage(error, "Trading dashboard could not load.") : "";

  return {
    dashboard,
    loading: isLoading,
    error: errorMessage,
    selectedSymbol,
    setSelectedSymbol,
    risk,
    setRisk: setRiskDraft,
    setDashboard,
    loadDashboard,
  };
}